import { render, staticRenderFns } from "./EncabezadoComponent.vue?vue&type=template&id=6df4b9b3&scoped=true&"
import script from "./EncabezadoComponent.vue?vue&type=script&lang=js&"
export * from "./EncabezadoComponent.vue?vue&type=script&lang=js&"
import style0 from "./EncabezadoComponent.vue?vue&type=style&index=0&id=6df4b9b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4b9b3",
  null
  
)

export default component.exports